<!-- 雷达图配置 -->
<template>
  <div>
    <el-collapse accordion>
      <el-collapse-item title="线条">
        <el-form-item label="线条宽度">
          <el-input-number v-model="main.activeOption.lineWidth" size="small" controls-position="right">
          </el-input-number>
        </el-form-item>
        <el-form-item label="标记点形状">
          <el-select v-model="main.activeOption.symbolKind" size="small">
            <el-option v-for="(item, index) in symbolKind" :key="index" :label="item.label" :value="item.value"/>
          </el-select>
        </el-form-item>
        <el-form-item label="标记点直径">
          <el-input-number v-model="main.activeOption.symbolSize" size="small" controls-position="right">
          </el-input-number>
        </el-form-item>
        <el-form-item label="显示面积">
          <el-switch v-model="main.activeOption.areaStyle" size="small">
          </el-switch>
        </el-form-item>
        <el-form-item label="区域透明度" v-if="main.activeOption.areaStyle">
          <el-slider v-model="main.activeOption.areaOpacity" :max="1" :step="0.1">
          </el-slider>
        </el-form-item>
        <el-form-item label="维度颜色">
          <colorPicker v-model="main.activeOption.indicatorColor"></colorPicker>
        </el-form-item>
        <el-form-item label="斑马纹">
          <el-switch v-model="main.activeOption.splitAreaShow" size="small">
          </el-switch>
        </el-form-item>
        <el-form-item label="填充色浅" v-if="main.activeOption.splitAreaShow">
          <colorPicker v-model="main.activeOption.splitAreaColor"></colorPicker>
        </el-form-item>
        <el-form-item label="填充色深" v-if="main.activeOption.splitAreaShow">
          <colorPicker v-model="main.activeOption.splitAreaColor2"></colorPicker>
        </el-form-item>
        <el-form-item label="线条个性化">
          <el-button type="primary" @click="showTool = true">配置</el-button>
        </el-form-item>
      </el-collapse-item>
      <el-collapse-item title="指标轴">
        <y-axis isRadar :main="main" :prop="main.activeOption"></y-axis>
      </el-collapse-item>
    </el-collapse>
  </div>
  <el-dialog draggable v-model="showTool" title="线条个性化配置" align-center append-to-body width="840">
    <RaderSet ref="raderSet" v-if="showTool" :main="main"></RaderSet>
    <template v-slot:footer>
      <el-button @click="showTool = false">取消</el-button>
      <el-button type="primary" @click="handleOkClick">保存</el-button>
    </template>
  </el-dialog>
</template>

<script>
import yAxis from './commonSet/yAxis.vue'
import colorPicker from './commonSet/color-picker.vue';
import RaderSet from './raderCustomSet.vue'

export default {
  name: "radar",
  inject: ["main"],
  components: {yAxis, colorPicker, RaderSet},
  data() {
    return {
      showTool: false,
      symbolKind: [{label: "默认", value: "emptyCircle"}, {label: "圆形", value: "circle"}, {
        label: "正方形",
        value: "rect"
      }, {label: "三角形", value: "triangle"}, {label: "菱形", value: "diamond"}, {label: "别针", value: "pin"}]
    }
  },
  methods: {
    handleOkClick() {
      this.main.activeOption.lineCustomSet = this.$refs.raderSet.getSetting()
      this.showTool = false
    }
  }
};
</script>

<style></style>